// pages/LoginPage.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { register } from '../../features/auth/authSlice';
import { createUserWithEmail } from '../../features/user/userSlice';

import loginImage from "../../images/login-bg-1.jpg";
import beetinqlogowhite from "../../images/beetinq/beetinqlogowhite.png";

function RegisterEmail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, isError, message } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    email: '',
    parola: '',
    parolaKontrol: '',
  });

  const { email, parola, parolaKontrol } = formData;
  const from = location.state?.from?.pathname || "/MyProfile";

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

  }, [isError, message]);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!email || !parola || !parolaKontrol) {
      toast.warning("Lütfen e-posta ve şifrenizi girin.");
      return;
    }

    if (parola !== parolaKontrol) {
      toast.warning("Parolalar eşleşmedi");
      return;
    }

    try {
      const authUser = await dispatch(register({ email, parola })).unwrap();
      await dispatch(createUserWithEmail(authUser)).unwrap();
      navigate(from);
    } catch (error) {
      toast.error(error || "Kayıt sırasında bir hata oluştu.");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-aside-left" style={{ backgroundImage: "url(" + loginImage + ")" }}>
        <Link to="/" className="login-logo">
          <img src={beetinqlogowhite} alt="" width={"60%"} />
        </Link>
        <div className="login-description">
          <h2 className="text-white mb-4">Toplantılarınız<br></br>İş Etkinlikleriniz<br></br>için Ortak Platform</h2>
          <p className="fs-16">beetinq ile Toplantı ve İş Etkinliği oluşturun, paylaşın ve iş birliği yapın. En büyük iş ağı platformunda yerinizi alın.</p>
          <ul className="social-icons mt-4">
            <li><Link to={"https://www.facebook.com/beetinq"}><i className="fa fa-facebook"></i></Link></li>
            <li><Link to={"https://www.instagram.com/beetinq"}><i className="fa fa-instagram"></i></Link></li>
            <li><Link to={"https://www.linkedin.com/company/beetinq"}><i className="fa fa-linkedin"></i></Link></li>
            <li><Link to={"https://beetinq.com"}><i className="fa fa-globe"></i></Link></li>
          </ul>
          <div className="mt-5">
            <Link to={"https://beetinq.com/"} className="text-white">© 2021 beetinq</Link>
          </div>
        </div>
      </div>
      <div className="login-aside-right">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-6 col-xxl-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">

                    <div className=" mb-3">
                      <h2 className="text-info">Hoşgeldiniz</h2>
                    </div>

                    <h4 className=" mb-4 ">Bilgileri girerek hesap oluşturun</h4>

                    <form onSubmit={onSubmit}>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>E-posta Adresiniz</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control  mb-3"
                          name="email"
                          value={email}
                          onChange={onChange}
                          placeholder="E-posta"
                          autoComplete="email"
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>Şifreniz</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control  mb-3"
                          name="parola"
                          value={parola}
                          onChange={onChange}
                          placeholder="Şifre"
                          autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label className="">
                          <strong>Şifre Tekrar</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control  mb-3"
                          name="parolaKontrol"
                          value={parolaKontrol}
                          onChange={onChange}
                          placeholder="Şifre Tekrar"
                          autoComplete="new-password"
                        />
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-info btn-block"
                          disabled={isLoading}
                        >
                          {isLoading ? "Kayıt yapılıyor..." : "Kayıt Ol"}
                        </button>
                      </div>
                    </form>

                    <div className="text-center mt-3">
                      <p>veya</p>
                      <button
                        type="button"
                        className="btn btn-outline-info btn-block"
                        onClick={() => navigate('/loginphone')}>
                        Telefon ile Giriş Yap
                      </button>
                    </div>

                    <div className="text-center mt-3">
                      <p>Zaten hesabınız var mı?</p>
                      <button
                        type="button"
                        className="btn btn-outline-info btn-block"
                        onClick={() => navigate('/loginemail')}
                      >
                        E-posta ile Giriş Yap
                      </button>
                    </div>

                    <div id="recaptcha"></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default RegisterEmail;
